import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from './Toast';
import configService from '../services/configService';
import Logo from './Logo';
import { Button } from './figma/FigmaComponents';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [billingLoading, setBillingLoading] = useState(false);
  const [modules, setModules] = useState({});
  const { user, logout } = useAuth();
  const { showToast } = useToast();

  const handleLogout = async () => {
    await logout();
    window.location.href = '/';
  };

  const handleBilling = async () => {
    try {
      setBillingLoading(true);
      const response = await configService.createBillingPortalSession();
      setTimeout(() => {
        window.location.href = response.url;
      }, 800);
    } catch (error) {
      console.error('Failed to open billing portal:', error);
      showToast('Unable to open billing portal. Please try again.', 'error');
      setBillingLoading(false);
    }
  };

  return (
    <header className="w-full bg-white border-b border-gray-100 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
          <Link to={user ? "/dashboard" : "/"}>
            <Logo className="h-8" />
          </Link>
          </div>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {user ? (
              <>
                <Link to="/dashboard" className="text-sm font-medium text-gray-700 hover:text-blue-600">
                  Dashboard
                </Link>
                <Link to="/setup" className="text-sm font-medium text-gray-700 hover:text-blue-600">
                  Setup
                </Link>
                <Link to="/skills" className="text-sm font-medium text-gray-700 hover:text-blue-600">
                  Skills
                </Link>
                <Link to="/bookings" className="text-sm font-medium text-gray-700 hover:text-blue-600">
                  Bookings
                </Link>
                <button 
                  onClick={handleBilling}
                  disabled={billingLoading}
                  className="text-sm font-medium text-gray-700 hover:text-blue-600 bg-transparent border-none cursor-pointer flex items-center gap-1"
                >
                  {billingLoading && (
                    <div className="w-3 h-3 border border-gray-400 border-t-transparent rounded-full animate-spin"></div>
                  )}
                  {billingLoading ? 'Opening...' : 'Billing'}
                </button>
                <button 
                  onClick={handleLogout}
                  className="text-sm font-medium text-gray-700 hover:text-blue-600"
                >
                  Logout
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="text-sm font-medium text-gray-700 hover:text-blue-600">
                  Login
                </Link>
                <Link to="/signup">
                  <Button variant="primary" className="text-sm">
                    Join Waitlist
                  </Button>
                </Link>
              </>
            )}
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-gray-700 hover:text-blue-600 focus:outline-none"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-gray-100">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {user ? (
                <>
                  <Link to="/dashboard" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-blue-600">
                    Dashboard
                  </Link>
                  <Link to="/setup" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-blue-600">
                    Setup
                  </Link>
                  <Link to="/skills" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-blue-600">
                    Skills
                  </Link>
                  <Link to="/bookings" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-blue-600">
                    Bookings
                  </Link>
                  <button 
                    onClick={handleBilling}
                    disabled={billingLoading}
                    className="block w-full text-left px-3 py-2 text-base font-medium text-gray-700 hover:text-blue-600 bg-transparent border-none cursor-pointer"
                  >
                    {billingLoading ? 'Opening Billing...' : 'Billing'}
                  </button>
                  <button 
                    onClick={handleLogout}
                    className="block w-full text-left px-3 py-2 text-base font-medium text-gray-700 hover:text-blue-600"
                  >
                    Logout
                  </button>
                </>
              ) : (
                <>
                  <Link to="/login" className="block px-3 py-2 text-base font-medium text-gray-700 hover:text-blue-600">
                    Login
                  </Link>
                  <div className="px-3">
                    <Link to="/signup">
                      <Button variant="primary" fullWidth className="text-base">
                        Join Waitlist
                      </Button>
                    </Link>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;